import VenoBox from 'venobox/dist/venobox.min';

new VenoBox({
    selector: '.venobox'
});
